<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12 5.00005V19.0001C12 19.891 10.9229 20.3371 10.2929 19.7072L6.58579 16.0001H3C2.44772 16.0001 2 15.5523 2 15.0001V9.00005C2 8.44777 2.44772 8.00005 3 8.00005H6.58579L10.2929 4.29294C10.9229 3.66298 12 4.10915 12 5.00005ZM10 7.41427L7.70711 9.70716C7.51957 9.89469 7.26522 10.0001 7 10.0001H4V14.0001H7C7.26522 14.0001 7.51957 14.1054 7.70711 14.2929L10 16.5858V7.41427ZM15.7071 8.29294L18 10.5851L20.2929 8.29294C20.6534 7.93246 21.2206 7.90473 21.6129 8.20976L21.7071 8.29294C22.0676 8.65343 22.0953 9.22066 21.7903 9.61295L21.7071 9.70716L19.415 12.0001L21.7071 14.2929C22.0976 14.6835 22.0976 15.3166 21.7071 15.7072C21.3166 16.0977 20.6834 16.0977 20.2929 15.7072L18 13.4151L15.7071 15.7072C15.3466 16.0676 14.7794 16.0954 14.3871 15.7903L14.2929 15.7072C13.9324 15.3467 13.9047 14.7794 14.2097 14.3872L14.2929 14.2929L16.585 12.0001L14.2929 9.70716C13.9024 9.31663 13.9024 8.68347 14.2929 8.29294C14.6834 7.90242 15.3166 7.90242 15.7071 8.29294Z"
    fill="currentColor"
  />
</svg>
